module.exports = __webpack_public_path__ + "static/images/bp-bg3.85ede06.png";